<div class="screenshot-annotator">
  <!-- Toolbar -->
  <div class="annotator-toolbar mb-2">
    <div class="btn-group btn-group-sm me-2" role="group">
      <button
        type="button"
        class="btn"
        [class.btn-primary]="activeTool === 'pen'"
        [class.btn-outline-secondary]="activeTool !== 'pen'"
        (click)="selectTool('pen')"
        [title]="'BugReport.toolPen' | translate"
      >
        <i class="bi bi-pencil"></i>
      </button>
      <button
        type="button"
        class="btn"
        [class.btn-primary]="activeTool === 'rectangle'"
        [class.btn-outline-secondary]="activeTool !== 'rectangle'"
        (click)="selectTool('rectangle')"
        [title]="'BugReport.toolRectangle' | translate"
      >
        <i class="bi bi-square"></i>
      </button>
      <button
        type="button"
        class="btn"
        [class.btn-primary]="activeTool === 'arrow'"
        [class.btn-outline-secondary]="activeTool !== 'arrow'"
        (click)="selectTool('arrow')"
        [title]="'BugReport.toolArrow' | translate"
      >
        <i class="bi bi-arrow-up-right"></i>
      </button>
    </div>

    <!-- Color picker -->
    <input
      type="color"
      class="form-control form-control-color color-picker-sm"
      [(ngModel)]="drawColor"
      [title]="'BugReport.annotationColor' | translate"
    />

    <!-- Undo / Reset -->
    <div class="btn-group btn-group-sm ms-2" role="group">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="undo()"
        [disabled]="!hasAnnotations"
        [title]="'BugReport.annotationUndo' | translate"
      >
        <i class="bi bi-arrow-counterclockwise"></i>
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="resetAnnotations()"
        [disabled]="!hasAnnotations"
        [title]="'BugReport.annotationReset' | translate"
      >
        <i class="bi bi-trash3"></i>
      </button>
    </div>
  </div>

  <!-- Canvas -->
  <div class="canvas-container" #canvasContainer>
    <canvas
      #annotationCanvas
      class="annotation-canvas"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointerleave)="onPointerUp($event)"
    ></canvas>
  </div>
</div>
